<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon
      :disabled="!this.enableDocumentItemEdit()">
        <v-icon :color="ui.btnColor"> create </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            Edit Risk Assessment
            <v-spacer/>
            {{displayDocumentIDGTypeA(riskAssessment.basic.tag, riskAssessment.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Risk Identification
                </div>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="localForm.title"
                  label="risk assessment title"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-text-field
                  v-model="localForm.id"
                  label="risk id"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="sell"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1 offset-sm0>
                  <v-text-field
                  v-model="localForm.ref"
                  label="reference"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="share"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Scenario and Context
                </div>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <v-flex xs10 offset-xs1>
                  <InfoDateAgoName :data="this.riskAssessment.stats"/>
                </v-flex>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs10 offset-xs1>
                  <v-textarea
                  v-model="localForm.com"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="mustBeLessThanLarge"
                  hint="risk assessment description"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Barriers and Risk Controls
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="localForm.cause"
                  label="potential causes"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="low_priority"
                  hint="existing barriers to control risk"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="localForm.bar"
                  label="existing barriers"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="shield"
                  required
                  hint="existing barriers to control risk"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="localForm.cont"
                  label="risk controls"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="health_and_safety"
                  hint="additional or existing risk control"
                  required
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs5 offset-xs1>
                  <v-select
                  v-model="localForm.bars"
                  :items="riskStrengthStatusOptions"
                  prepend-icon="assessment"
                  hint="barrier stat."
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs5>
                  <v-select
                  v-model="localForm.conts"
                  :items="riskStrengthStatusOptions"
                  prepend-icon="analytics"
                  hint="control stat."
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Risk Assessment
                </div>
                <v-spacer/>
                <div class="ml-4 mt-4 mr-4" v-if="riskValueCalc(this.localForm.cons, this.localForm.like) > 0">
                  R = {{riskValueCalc(this.localForm.cons, this.localForm.like)}}
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-select
                  v-model="localForm.type"
                  :items="riskAssessmentTypeOptions"
                  prepend-icon="emergency"
                  label="type"
                  hint="risk type"
                  :rules="ruleMustBeSelected"
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1 offset-sm0>
                  <v-text-field
                  v-model="localForm.comp"
                  prepend-icon="today"
                  hint="compliance"
                  label="reg."
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-select
                  v-model="localForm.cond"
                  :items="riskAssessmentConditionOptions"
                  prepend-icon="swap_horizontal_circle"
                  label="condition"
                  :rules="ruleMustBeSelected"
                  hint="risk condition"
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1 offset-sm0>
                  <v-select
                  v-model="localForm.time"
                  :items="riskAssessmentTimeOptions"
                  prepend-icon="schedule"
                  label="timing"
                  :rules="ruleMustBeSelected"
                  hint="risk timing"
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-select
                  v-model="localForm.cat"
                  :items="riskCategoryOptions"
                  prepend-icon="scatter_plot"
                  label="category"
                  hint="risk category"
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1 offset-sm0>
                  <v-text-field
                  v-model="localForm.rate"
                  prepend-icon="warning"
                  hint="risk rating"
                  :label="riskRatingCalc(this.localForm.cons, this.localForm.like)"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs5 offset-xs1>
                  <v-select
                  v-model="localForm.cons"
                  :items="riskConsequenceOptions"
                  label="consequence"
                  prepend-icon="leaderboard"
                  hint="consequence"
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs5>
                  <v-select
                  v-model="localForm.like"
                  :items="riskLikelihoodOptions"
                  label="likelihood"
                  prepend-icon="casino"
                  hint="likelihood"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="localForm.sum"
                  label="conclusion"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="adjust"
                  required
                  hint="risk assessment conclusion"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> exit_to_app </v-icon>
                Close
            </v-btn>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> exit_to_app </v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn @click="deleteRiskAssessment()" color="error" flat
            class="hidden-xs-only"
               :disabled="this.getRiskAssessmentList.length < 1">
              <v-icon left> delete </v-icon>
                Delete
            </v-btn>
            <v-btn @click="deleteRiskAssessment()" color="error" flat
               :disabled="this.getRiskAssessmentList.length < 1"
               class="hidden-sm-and-up">
              <v-icon> delete </v-icon>
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> create </v-icon>
                Update
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> create </v-icon>
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import master from "@/data/forms/mixins/master.js";
import attachOptions from "@/data/options/mixins/attachOptions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import causeOptions from "@/data/options/mixins/causeOptions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import InfoDateAgoName from "@/frame/display/components/InfoDateAgoName";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import riskOptions from "@/data/options/mixins/riskOptions.js";
import riskFunctions from "@/data/functions/mixins/riskFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    master,
    attachOptions,
    rulesTextfield,
    dateFunctions,
    causeOptions,
    uisettings,
    riskOptions,
    docRevsModFunctions,
    numberFunctions,
    apptheme,
    displayFunctions,
    riskFunctions,
    documentFunctions
  ],
  components: {
    InfoDateAgoName
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetailStats",
      "getRiskAssessmentList",
      "getUser",
      "getRiskAssessmentListCounter"
    ]),
    reactiveAttachmentList() {
      return this.getRiskAssessmentList;
    },
    // selected task item
    selectedAttachmentItem() {
      return this.riskAssessment;
    },
    textTitle() {
      let k = "title";
      let temp = this.ui.textColor + "--text ";
      k = temp + k;
      return k;
    }
  },
  props: {
    riskAssessment: {
      type: Object
    }
  },
  data() {
    return {
      hideActions: true,
      dialog: false,
      valid: false,
      enableSpinner: false,
      localForm: {
        title: "",
        id: "",
        com: "",
        cat: "", // category prior
        cons: "", // consequence
        like: "", // liklekhood
        risk: "", // current risk
        rate: "", // current rate D4 (not used for saving)
        rank: "",
        calc: "", // risk calculation
        comp: "", // compliance risk
        sum: "", // risk summary and closeing comments
        cause: "", // potentail causes
        bar: "", // barriers that can be take credit for this outcome
        bars: "", // barriers status
        barr: "",
        cont: "", // controls, baseline, or more
        contr: "",
        conts: "" // controls, status
      }
    };
  },
  beforeMount() {
    this.localForm.title = this.riskAssessment.basic.title;
    this.localForm.id = this.riskAssessment.basic.id;
    this.localForm.bar = this.riskAssessment.char.bar;
    this.localForm.bars = this.riskAssessment.char.bars;
    this.localForm.cont = this.riskAssessment.char.cont;
    this.localForm.cause = this.riskAssessment.char.cause;
    this.localForm.conts = this.riskAssessment.char.conts;
    this.localForm.cat = this.riskAssessment.char.cat;
    this.localForm.cons = this.riskAssessment.char.cons;
    this.localForm.like = this.riskAssessment.char.like;
    this.localForm.ref = this.riskAssessment.char.ref;
    this.localForm.sum = this.riskAssessment.char.sum;
    this.localForm.com = this.riskAssessment.char.com;
    this.localForm.type = this.riskAssessment.char.type;
    this.localForm.comp = this.riskAssessment.char.comp;
    this.localForm.cond = this.riskAssessment.char.cond;
    this.localForm.time = this.riskAssessment.char.time;
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    deleteRiskAssessment() {
      let newList = [];
      let oldList = this.getRiskAssessmentList;
      let idi = this.riskAssessment.basic.idi;
      // loop
      for (var i = 0; i < oldList.length; i++) {
        // eslint-disable-next-line
        if (idi !== oldList[i].basic.idi) {
          // newID = newID + 1;
          // list[i].basic.id = newID;
          // LOGIC TEST
          console.log(idi);
          console.log(oldList[i].basic.idi);
          console.log(newList);
          newList.push(oldList[i]);
        }
      }
      this.$store.dispatch("changeRiskAssessmentList", newList);
      // eslint-disable-next-line
      this.$store.dispatch("changeRiskAssessmentListCounter", this.getRiskAssessmentListCounter + 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // riskAssessment removed.
      // eslint-disable-next-line
      let risk = this.calcRiskTotal(this.getRiskAssessmentList)
      // eslint-disable-next-line
      this.$store.dispatch("changeRiskAssessmentListRiskCounter", risk);
      // HELP
      console.log("AttachmentEdit");
      console.log("deleteRiskAssessment");
      console.log(newList);
      // Close dialog
      this.dialog = false;
    },
    validate() {
      // cosole.log(this.taskForm)
      if (this.$refs.form.validate() === true) {
        // hi
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // add dates
        let tempForm = this.riskAssessment;

        // CHAR
        tempForm.basic.title = this.localForm.title;
        tempForm.basic.id = this.localForm.id;
        tempForm.char.cause = this.localForm.cause;
        tempForm.char.com = this.localForm.com;
        tempForm.char.bar = this.localForm.bar;
        tempForm.char.bars = this.localForm.bars;
        tempForm.char.cont = this.localForm.cont;
        tempForm.char.conts = this.localForm.conts;
        tempForm.char.cat = this.localForm.cat;
        tempForm.char.cons = this.localForm.cons;
        tempForm.char.like = this.localForm.like;
        tempForm.char.sum = this.localForm.sum;
        tempForm.char.type = this.localForm.type;
        tempForm.char.cond = this.localForm.cond;
        tempForm.char.comp = this.localForm.comp;
        tempForm.char.time = this.localForm.time;
        tempForm.char.ref = this.localForm.ref;

        // STATS
        tempForm.stats.date = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST
        var tempRiskAssessmentList = this.getRiskAssessmentList;
        // eslint-disable-next-line
        tempRiskAssessmentList[this.riskAssessment.basic.id - 1] = this.tempForm;

        // STORE
        // eslint-disable-next-line
        this.$store.dispatch("changeRiskAssessmentList", tempRiskAssessmentList);
        // eslint-disable-next-line
        this.$store.dispatch("changeRiskAssessmentListCounter", this.getRiskAssessmentListCounter + 1);
        // eslint-disable-next-line
        let risk = this.calcRiskTotal(this.getRiskAssessmentList)
        // eslint-disable-next-line
        this.$store.dispatch("changeRiskAssessmentListRiskCounter", risk);
        // eslint-disable-next-line
        this.saveDocumentRevMod(5.13, 2); // riskAssessment removed
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // HELP
        console.log("");
        console.log("RISK ASSESSMENT EDIT");
        console.log(tempForm);
        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
